import { IonButton, IonModal } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { utilService } from "../../../../../services";
import { useHistory } from "react-router";
import "./ContactNumAlert.scss";
import { useTranslation } from "react-i18next";

interface ContainerProps {
  showContactNumAlert: boolean;
  showAlert: () => void;
  contactNumInputParams: any;
}
const ContactNumAlert: React.FC<ContainerProps> = (props: any) => {
  const { t } = useTranslation("settings");
  const [showContactModalAlert, setShowContactModalAlert] = useState(false);

  useEffect(() => {
    if (props.showContactNumAlert) {
      displayContactNumAlert();
    }
  }, []);

  let history = useHistory();

  const displayContactNumAlert = () => {
    setShowContactModalAlert(true);
  };

  const hideContactNumAlert = () => {
    setShowContactModalAlert(false);
    props.showAlert();
    history.push({
      pathname: "/client/menu-settings",
      state: { isMyContactNumberClicked: true },
    });
  };

  return (
    <IonModal
      isOpen={showContactModalAlert}
      className="contact-alert-modal"
      backdropDismiss={false}
    >
      <div className="alert-main-container">
        <div className="content-area">
          <h3 className="label">{t("reminder")}</h3>
          <div className="time-info-label">
            <span className="time-info">
              {t("phoneUpdateReminder")}{" "}
            </span>
            <span className="time-value">
              {utilService.getFormattedDateTime(
                props?.contactNumInputParams?.time
              )}
            </span>
          </div>
          <div className="message-wrapper">
            <div className="message-label">{t("message")}:</div>
            <div className="message-content">
              {props?.contactNumInputParams?.note}
            </div>
          </div>
        </div>

        <div className="alert-button-container">
          <div className="cancel-button-div">
            <IonButton
              color="medium"
              className="cancel-button secondary-btn button btn-curved"
              onClick={() => {
                setShowContactModalAlert(false);
              }}
            >
              {t("cancel")}
            </IonButton>
          </div>
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                hideContactNumAlert();
              }}
            >
              {t("update")}
            </IonButton>
          </div>
        </div>
      </div>
    </IonModal>
  );
};

export default ContactNumAlert;
